import {
  GET_COMPONENTES_SERIE,
  GET_COMPONENTES_SERIE_SUCCESS,
  SAVE_COMPONENTES_SERIE,
  SAVE_COMPONENTES_SERIE_SUCCESS
} from '../constants/ActionTypes';

export const getComponentesSerie = (params) => {
  return {
    type: GET_COMPONENTES_SERIE,
    payload: params
  };
};

export const getComponentesSerieSuccess = (data) => {
  return {
    type: GET_COMPONENTES_SERIE_SUCCESS,
    payload: data
  };
};

export const saveComponentesSerie = (data) => {
  return {
    type: SAVE_COMPONENTES_SERIE,
    payload: data
  };
};

export const saveComponentesSerieSuccess = (data) => {
  return {
    type: SAVE_COMPONENTES_SERIE_SUCCESS,
    payload: data
  };
};
